const removeNotifications = (items):string => `
	{
        notifications {
          updateNotificationItemsState(event: "delete", items: "${items}")
        }
    }
`;

export default removeNotifications;
